var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#660099"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M15.297 3.719c-.348-.353-.823-.552-1.32-.552-.495 0-.97.199-1.319.552l-.285.264H5.956c-1.694 0-2.786 1.055-2.786 2.638v6.655c-.034.695.224 1.373.712 1.868.565.505 1.307.765 2.064.723h5.805c.758.044 1.502-.216 2.068-.723.492-.494.755-1.171.723-1.868V7.033c.391-.354.676-.607.745-.675.345-.346.538-.815.538-1.304 0-.496-.19-.973-.528-1.335zm-1.81 9.557c.028.41-.117.812-.401 1.108-.37.312-.848.466-1.33.428H5.951c-.482.038-.96-.116-1.33-.428-.286-.295-.433-.698-.406-1.108V6.595c0-1.362 1.087-1.583 1.73-1.583h5.278L8.658 7.265c-.105.107-.186.235-.237.375l-.67 2c-.113.331-.027.698.221.945.174.17.406.266.65.269.096.003.193-.013.284-.048l1.995-.654c.125-.036.239-.1.333-.19l2.253-1.99v5.304zm1.055-7.668c-.195.195-3.33 2.971-3.979 3.547l-1.72.564.575-1.71c1.282-1.129 3.8-3.356 3.99-3.54.149-.156.355-.243.57-.243.215 0 .42.087.57.242.142.162.221.37.221.586.001.209-.083.408-.232.554h.005z",
    transform: "translate(-1157 -682) translate(1154 680) translate(3 2)"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.34794b011f0d07a01d0d0360318782a2.svg";
export { ForwardRef as ReactComponent };